import { render } from "./PartnerRegistrationList.vue?vue&type=template&id=202671d8"
import script from "./PartnerRegistrationList.vue?vue&type=script&lang=js"
export * from "./PartnerRegistrationList.vue?vue&type=script&lang=js"

import "./PartnerRegistrationList.vue?vue&type=style&index=0&id=202671d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__